import React, { useRef, useState, useContext } from "react";
import { Link, useLocation, Navigate } from "react-router-dom";

import LockOpenIcon from "@mui/icons-material/LockOpen";
import EmailIcon from "@mui/icons-material/Email";

import { HeadingOne } from "../../theme";
import { LoginBox } from "./login";
import { getTranslation, LanguageContext } from "../languageProvider";
import { SendPasswordResetEmail } from "../../firebase";
import { AuthContext } from "../authContextProvider";
import {
  selectNextOnEnter,
  UpdateInputChange,
  ReplaceWord,
} from "../shared/utility";
import { LayoutLogin } from "../layout/loginPage";
import FormHooks from "../shared/formHooks";

export const ForgotPassword = () => {
  const emailRef = useRef();
  const submitRef = useRef();

  const { user, appUser, snackbarHandler } = useContext(AuthContext);
  const { lang } = useContext(LanguageContext);
  const { state } = useLocation();

  const [formInputs, setFormInputs] = useState({
    email: {
      type: "input",
      label: "0002",
      icon: <EmailIcon />,
      value: "",
      validation: {
        required: true,
      },
      valid: false,
      touched: false,
      inputRef: emailRef,
      input: {
        type: "email",
        onKeyDown: (e) => selectNextOnEnter(e, submitRef),
      },
    },
    submit: {
      type: "submit",
      icon: <LockOpenIcon />,
      text: "0051",
      isSubmit: true,
      inputRef: submitRef,
      className: "btn-secondary",
      clicked: (e) => forgotPasswordSubmitHandler(e),
      valid: false,
    },
  });

  const inputChangeHandler = (e, key) =>
    setFormInputs(UpdateInputChange(formInputs, e.target.value, key));

  const forgotPasswordSubmitHandler = (e) => {
    if (formInputs.submit.valid) {
      e.preventDefault();
      let email = emailRef.current.value;
      SendPasswordResetEmail(email)
        .then(() =>
          snackbarHandler(
            ReplaceWord(getTranslation("0067"), "**EMAIL**", email),
            "success",
            "push"
          )
        )
        .catch((status) => snackbarHandler(getTranslation(`error${status}`)));
    }
  };
  if (user && appUser) {
    return <Navigate to={state ? state.from : "/dashboard"} />;
  } else {
    return (
      <LayoutLogin lang={lang}>
        <LoginBox>
          <HeadingOne marginBottom={30} textCenter data-translate="0068">
            {getTranslation("0068")}
          </HeadingOne>
          <FormHooks
            formInputs={formInputs}
            inputChange={inputChangeHandler}
            onSubmit={forgotPasswordSubmitHandler}
            size="md"
            layout="outline"
            hideError={true}
          />
          <span data-translate="0069">
            {getTranslation("0069")}
            <Link to="/" data-translate="0001">
              {getTranslation("0001") && getTranslation("0001").toLowerCase()}
            </Link>
            .
          </span>
        </LoginBox>
      </LayoutLogin>
    );
  }
};
